"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _hooks = require("../hooks");

var _ZoomOutMap = _interopRequireDefault(require("@material-ui/icons/ZoomOutMap"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = function styles(theme) {
  return {
    root: {
      padding: 0,
      boxShadow: "0 0 0 2px rgb(0 0 0 / 10%)",
      borderRadius: 4,
      background: "#fff",
      minWidth: 29,
      minHeight: 29,
      "&:hover": {
        background: "#f0f0f0"
      }
    }
  };
};

var ResetViewportControl = function ResetViewportControl(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var flyToDefault = (0, _hooks.useFlyToDefault)();
  return /*#__PURE__*/_react["default"].createElement(_core.Button, _extends({}, props, {
    onClick: flyToDefault
  }), children);
};

ResetViewportControl.defaultProps = {
  children: /*#__PURE__*/_react["default"].createElement(_ZoomOutMap["default"], null)
};
ResetViewportControl.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ResetViewportControl",
  "props": {
    "children": {
      "defaultValue": {
        "value": "<ZoomOutMap />",
        "computed": false
      },
      "required": false
    }
  }
};

var _default = (0, _core.withStyles)(styles)(ResetViewportControl);

exports["default"] = _default;